var _effectorFileName = "/builds/gmini/front-common/src/components/Marker/NumCircle.tsx";
import React from 'react';
import { Tooltip } from '@gmini/ui-kit';
import { DependencyText, NumCircleRoot, TitleText } from "./NumCircle.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NumCircle = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      tooltipTitle = _ref.tooltipTitle,
      onMouseOver = _ref.onMouseOver,
      onMouseLeave = _ref.onMouseLeave,
      styleProps = _ref.styleProps,
      disabled = _ref.disabled;

  var content = /*#__PURE__*/_jsx(NumCircleRoot, {
    style: styleProps,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    disabled: disabled,
    children: children
  });

  if (!tooltipTitle) {
    return content;
  }

  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    zIndex: 2000,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DependencyText, {
        children: "\u0417\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u044C:"
      }), /*#__PURE__*/_jsx(TitleText, {
        children: ' '.concat(tooltipTitle)
      })]
    }),
    children: content
  });
});
NumCircle.displayName = 'NumCircle';